import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Container, Typography, Paper, List, ListItem, ListItemText, Divider } from '@mui/material';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';
import { API_ENDPOINTS } from '../../config/api';
import { useAuth } from '../../contexts/AuthContext';

const Messages = () => {
    const [messages, setMessages] = useState([]);
    const { user } = useAuth();

    useEffect(() => {
        const fetchMessages = async () => {
            try {
                const response = await fetch(API_ENDPOINTS.contact.getAllMessages(), {
                    method: 'GET',
                    headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
                });
                const data = await response.json();
                setMessages(data.messages);
            } catch (error) {
                console.error('Mesajlar alınırken hata oluştu:', error);
            }
        };

        fetchMessages();
    }, []);

    // Sadece mertdgn35@gmail.com erişebilir
    if (!user || user.email !== 'mertdgn35@gmail.com') {
        return <Navigate to="/" replace />;
    }

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                İletişim Mesajları
            </Typography>
            <Paper elevation={3}>
                <List>
                    {messages.map((message, index) => (
                        <React.Fragment key={message.id}>
                            <ListItem alignItems="flex-start">
                                <ListItemText
                                    primary={
                                        <>
                                            <Typography component="span" variant="subtitle1" color="text.primary">
                                                {message.name}
                                            </Typography>
                                            <Typography component="span" variant="body2" color="text.secondary" sx={{ ml: 2 }}>
                                                {format(new Date(message.created_at), 'dd MMMM yyyy HH:mm', { locale: tr })}
                                            </Typography>
                                        </>
                                    }
                                    secondary={
                                        <>
                                            <Typography component="span" variant="body2" color="text.primary">
                                                {message.email}
                                            </Typography>
                                            {/* BURADA component="div" KULLANILMAMALI */}
                                            <Typography component="span" display="block" variant="body1" color="text.primary" sx={{ mt: 1 }}>
                                                {message.message}
                                            </Typography>
                                        </>
                                    }
                                />
                            </ListItem>
                            {index < messages.length - 1 && <Divider variant="inset" component="li" />}
                        </React.Fragment>
                    ))}
                </List>
            </Paper>
        </Container>
    );
};

export default Messages;